export const getLastSunday = (date: Date): Date => {
  date.setUTCHours(0, 0, 0, 0);
  const day = date.getUTCDay();
  const sunday = date.getUTCDate() - day + (day == 0 ? -7 : 0);
  return new Date(date.setUTCDate(sunday));
};
